



























import {
  saveProjectPropertyKey,
  SaveProjectPropertyKeyCommand
} from "@/api/project/project-properties-api";
import { Component, Vue } from "vue-property-decorator";

@Component({})
export default class ProjectPropertyKeyCreatePage extends Vue {
  command: SaveProjectPropertyKeyCommand = {
    name: ""
  };

  async submit() {
    await saveProjectPropertyKey(this.command);
    this.$router.push({ name: "project-property-keys" });
  }

  clickSubmitButton() {
    (this.$refs["btnSubmit"] as any).click();
  }
}
